module.exports = __webpack_public_path__ + "img/fire_tool_1.36c419a3.png";